module.exports = __webpack_public_path__ + "img/Size=20, Style=light.1420681e.svg";